import instance from '@/store/api/instance';

export let AdminLogin = function (data) {
    return instance.post('/admin/login', data)
}

export let AdminLogout = function () {
    return instance.post('/admin/do/logout')
}